export default function getBuilderLocalizedValue(value: BuilderLocalizedValue | string, locale: string): string {
  if (typeof value === "string") return value;

  return value[locale] ?? value.Default;
}
